import type { UseRecaptcha } from "./interface"
import { Recaptcha } from "~/capacitor/recaptcha"

export function useAndroidRecaptcha(): UseRecaptcha {
	const { public: { recaptcha: { androidKey } } } = useRuntimeConfig()

	// TODO: prevent multiple initialization in JS side.
	async function initialize() {
		await Recaptcha.init({ key: androidKey })
	}

	async function getCode(action: string) {
		await initialize()
		const { token } = await Recaptcha.getToken({ action })
		return token
	}

	return {
		getCode,
		initialize,
	}
}
